import { USER_TYPE, BOOKING_STATUS, PAYMENT_STATUS, TRANSACTION_TRANSFER_STATUS } from 'store/constant';

export const GetSportsType = function (sportsTypes, typesString) {
    if (typesString && sportsTypes) {
        const splitTypes = typesString.split(',');
        return splitTypes.map(x => {
            let findInd = sportsTypes.findIndex(st => st.code === x);
            return findInd >= 0 ? sportsTypes[findInd].display_name : 'NA';
        }).toString();
    }
    return '';
};

export const CapFirstChar = (str) => {
    return str ? str.replace(/^\w/, (c) => c.toUpperCase()) : str;
};

export const GetUserType = function (userType) {
    let findObj = USER_TYPE.find(st => st.value === userType);
    return findObj ? findObj.name : userType;
};

export const ChangeCurrencyFormat = (amount) => {
    return parseFloat(amount).toFixed(2);
};

export const GetBookingStatus = (status) => {
    let findObj = BOOKING_STATUS.find(st => st.value === status);
    return findObj ? findObj.name : status;
};

export const GetPaymentStatus = (status) => {
    let findObj = PAYMENT_STATUS.find(st => st.value === status);
    return findObj ? findObj.name : status;
};

export const GetTransferStatus = (status) => {
    let findObj = TRANSACTION_TRANSFER_STATUS.find(st => st.value === status);
    return findObj ? findObj.name : status;
};

export const NumberLocale = (num) => {
    return num ? num.toLocaleString() : 0;
};